<!-- 
Contents of the LEVY ESTIMATOR tab of the levy collection setup page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="getBreadcrumbs('setup')"
      :subtitle="statusDescription"
      title="Setup"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-setup"
      user-guide-section="estimator-templates"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs>
      <estimator-panel :levy-collection-id="levyCollectionId"/>
      <v-divider/>
      <h3 class="title ml-3 mt-4">
        Templates
        <our-user-guide-button topic="levy-collection-setup" section="templates" in-title/>
      </h3>
      <div class="mx-5">
        <estimator-template-listing :levy-collection-id="levyCollectionId" @click="showEditor"/>
      </div>
      <estimator-template-edit-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" :type="type" />
    </tabs>
  </div>
</template>

<script>
import levyCollectionSetupMixins from "./mixins";
import EstimatorPanel from "@/components/estimator-templates/EstimatorPanel.vue";
import EstimatorTemplateListing from "@/components/estimator-templates/EstimatorTemplateListing.vue";
import EstimatorTemplateEditDialog from "@/components/estimator-templates/EstimatorTemplateEditDialog.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";

export default {
  components: {
    Tabs,
    LevyCollectionNavigator,
    EstimatorTemplateListing,
    EstimatorTemplateEditDialog,
    EstimatorPanel
  },
  mixins: [levyCollectionSetupMixins],
  data() {
    return {
      showEditDialog: false,
      type: null
    };
  },
  methods: {
    showEditor(type) {
      this.type = type;
      this.showEditDialog = true;
    }
  }
};
</script>
